<kendo-multiselect 
  [data]="packages"
  [filterable]="true"
  [textField]="'nom'"
  [valueField]="'id'"
  (filterChange)="handleFilter($event)"
  (valueChange)="onValueChange($event)"
>
</kendo-multiselect>
